import { get, last } from 'lodash-es';
import { getTmvHistory } from 'client/data/models/partner-offer-model';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

export const TMV_API_CUTOFF_YEAR = 1990;

export const getHistoryTrendCopy = async ({
  zipCode,
  styleId,
  mileage,
  monthlyMiles = 12000,
  optionIds,
  condition,
  creativeId,
  predictionCreativeId,
}) => {
  let showDownwardTrendCopy = false;
  let showUpwardTrendCopy = false;

  const weeklyTmvHistory = await getTmvHistory({
    styleId,
    zip: zipCode,
    mileage,
    monthlyMileage: monthlyMiles,
    optionIds,
    condition: condition?.toUpperCase(),
    interval: 'WEEK',
  });
  const noTmvData = weeklyTmvHistory?.noTmvData;
  const weeklyTmvHistoryPrices = get(weeklyTmvHistory, 'pricesWithAdjustments.adjustedPrices', []);
  const weeklyTmvHistoryLastPrice = get(last(weeklyTmvHistoryPrices), 'price.usedTradeIn');
  const weeklyTmvHistoryBeforeLastPrice = get(weeklyTmvHistoryPrices, [
    weeklyTmvHistoryPrices.length - 2,
    'price',
    'usedTradeIn',
  ]);

  if (weeklyTmvHistoryLastPrice && weeklyTmvHistoryBeforeLastPrice) {
    showDownwardTrendCopy =
      weeklyTmvHistoryLastPrice < weeklyTmvHistoryBeforeLastPrice ||
      weeklyTmvHistoryLastPrice === weeklyTmvHistoryBeforeLastPrice;
    showUpwardTrendCopy = weeklyTmvHistoryLastPrice > weeklyTmvHistoryBeforeLastPrice;

    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
      event_data: {
        action_name: TrackingConstant.ACTION_APPRAISE_VEHICLE,
        subaction_name: TrackingConstant.HISTORICAL_TMV_DELTA,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
        creative_id: creativeId,
        value: weeklyTmvHistoryLastPrice - weeklyTmvHistoryBeforeLastPrice,
      },
    });
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_END,
      event_data: {
        action_name: TrackingConstant.ACTION_APPRAISE_VEHICLE,
        subaction_name: TrackingConstant.TMV_PREDICTION,
        action_category: TrackingConstant.USER_ACTION_CATEGORY,
        creative_id: predictionCreativeId,
        value: showDownwardTrendCopy ? 'downward_prediction' : 'upward_prediction',
      },
    });
  }

  return { showDownwardTrendCopy, showUpwardTrendCopy, noTmvData };
};
